// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "bundle." + {"8":"e6e129e4965cb3440537","332":"079bedbf5c0821eb7f7e"}[chunkId] + ".js";
};